module.exports = __webpack_public_path__ + "img/teamMatch.a34bae58.svg";